import React from 'react';
import { Droplet, Droplets, Wheat } from 'lucide-react';
import { Toggle } from '../ui/toggle';
import { Section, FormField } from './InspectionShared';

const ResourcesSection = ({ formData, setFormData, toggleArray, isQuickInspection, handleSectionPhoto }) => {
  return (
    <Section 
      title="Resources & Feeding" 
      icon={<Droplet className="h-6 w-6 text-amber-600" />}
      collapsible={isQuickInspection}
      defaultCollapsed={isQuickInspection}
      onPhoto={handleSectionPhoto}
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormField label="Nectar Level">
          <div className="flex gap-2">
            {['L', 'M', 'H'].map((level) => (
              <Toggle
                key={level}
                pressed={formData.nectar_level === level}
                onPressedChange={() => setFormData({ ...formData, nectar_level: level })}
                data-testid={`nectar-${level}`}
                className="h-16 flex-1 data-[state=on]:bg-green-600 data-[state=on]:text-white flex items-center justify-center gap-1"
              >
                <Droplets className="h-4 w-4" />
                {level}
              </Toggle>
            ))}
          </div>
        </FormField>
        <FormField label="Pollen Level">
          <div className="flex gap-2">
            {['L', 'M', 'H'].map((level) => (
              <Toggle
                key={level}
                pressed={formData.pollen_level === level}
                onPressedChange={() => setFormData({ ...formData, pollen_level: level })}
                data-testid={`pollen-${level}`}
                className="h-16 flex-1 data-[state=on]:bg-orange-600 data-[state=on]:text-white flex items-center justify-center gap-1"
              >
                <Wheat className="h-4 w-4" />
                {level}
              </Toggle>
            ))}
          </div>
        </FormField>
        <FormField label="Honey Around Brood">
          <div className="flex gap-2">
            {['L', 'M', 'H'].map((level) => (
              <Toggle
                key={level}
                pressed={formData.honey_brood_level === level}
                onPressedChange={() => setFormData({ ...formData, honey_brood_level: level })}
                data-testid={`honey-brood-${level}`}
                className="h-16 flex-1 data-[state=on]:bg-amber-600 data-[state=on]:text-white flex items-center justify-center gap-1"
              >
                <Droplet className="h-4 w-4" />
                {level}
              </Toggle>
            ))}
          </div>
        </FormField>
      </div>

      <FormField label="Feeding">
        <div className="grid grid-cols-2 gap-2">
          {['Fed', 'Not Fed'].map((feed) => (
            <Toggle
              key={feed}
              pressed={formData.feeding === feed}
              onPressedChange={() => setFormData({ ...formData, feeding: feed })}
              data-testid={`feeding-${feed.toLowerCase().replace(' ', '-')}`}
              className="h-16 data-[state=on]:bg-lime-600 data-[state=on]:text-white"
            >
              {feed}
            </Toggle>
          ))}
        </div>
      </FormField>

      {formData.feeding === 'Fed' && (
        <>
          <FormField label="Feed Type (Select all that apply)">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {['Syrup', '1:1', '2:1', 'Pollen Patty', 'Fondant', 'Honey', 'Nutrition'].map((type) => (
                <Toggle
                  key={type}
                  pressed={formData.feed_type.includes(type)}
                  onPressedChange={() => toggleArray('feed_type', type)}
                  data-testid={`feed-type-${type.toLowerCase().replace(/[:\s]/g, '-')}`}
                  className="h-16 data-[state=on]:bg-lime-600 data-[state=on]:text-white"
                >
                  {type}
                </Toggle>
              ))}
            </div>
          </FormField>

          <FormField label="Feeder Type">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {['Entrance', 'Frame', 'Zip-lock', 'Jar', 'Top Feeder'].map((feeder) => (
                <Toggle
                  key={feeder}
                  pressed={formData.feeder_type === feeder}
                  onPressedChange={() => setFormData({ ...formData, feeder_type: feeder })}
                  data-testid={`feeder-${feeder.toLowerCase().replace(/[\s-]/g, '-')}`}
                  className="h-16 data-[state=on]:bg-lime-600 data-[state=on]:text-white"
                >
                  {feeder}
                </Toggle>
              ))}
            </div>
          </FormField>
        </>
      )}
    </Section>
  );
};

export default ResourcesSection;
